import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="bg-[#000000] p-2 md:p-8 mb-10 md:mb-0">
        <div className="lg:px-[calc((100%-1250px)/2)] grid grid-cols-1 lg:grid-cols-4 lg:gap-20">
          <div className="w-[300px] md:w-[500px] lg:w-[370px] text-[#ffffff]">
            <h2 className="text-[18px] font-bold mb-4">Wehelpufirst</h2>
            <p className="text-[16px] font-[400] lg:w-[280px] xl:w-[340px] text-justify">
              Wehelpufirst strive to bridge the gap between user
              and trusted professionals, offering seamless access to services
              tailored to your needs. With reliability and convenience at the
              core, we are committed to making your experience hassle-free and
              fulfilling.
            </p>


          </div>

          <div className="mt-6 md:mt-5 lg:mt-0 w-[200px] lg:ml-[60px]">
            <h2 className="text-[18px] font-bold text-[#ffffff] mb-2 md:mb-4">
              Company
            </h2>
            <ul className="list-none leading-[30px] space-y-1 text-[16px] font-[400]  text-[#ffffff]">
                <li              onClick={() => window.scrollTo(0, 0)}
>About</li>
                <li              onClick={() => window.scrollTo(0, 100)}
>Categories</li>
                <li              onClick={() => window.scrollTo(0, 0)}
>Services</li> {/* Add this link if you have a services page */}
            </ul>
          </div>

          <div className="mt-1 md:mt-0 w-[200px] ">
            <h2 className="text-[18px] font-bold text-[#ffffff] mb-2 md:mb-4">
              Policy
            </h2>
            <ul className="list-none leading-[30px] space-y-1 text-[16px] font-[400]  text-[#ffffff]">
              <Link to={"/terms-and-conditions"}>
                <li className="">Terms & Conditions</li>
              </Link>
              <Link to={"/privacy-policy"}>
                <li className="">Privacy Policy</li>
              </Link>
              <Link to={"/cancellation-policy"}>
                <li className="">Cancellation Policy</li>
              </Link>
            </ul>
          </div>

          <div className="mt-1 md:mt-0 w-[200px] ">
            <h2 className="text-[18px] font-bold text-[#ffffff] mb-2 md:mb-4">
              Follow Us            </h2>

            <div className="flex gap-4">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_2296_4576)">
                  <path fillRule="evenodd" clipRule="evenodd" d="M30 48C41.0457 48 50 39.0457 50 28C50 16.9543 41.0457 8 30 8C18.9543 8 10 16.9543 10 28C10 39.0457 18.9543 48 30 48Z" fill="white" />
                </g>
                <path fillRule="evenodd" clipRule="evenodd" d="M32.5446 25.7991C32.2324 25.7003 31.8733 25.6345 31.5454 25.6345C31.1395 25.6345 30.2651 25.9143 30.2651 26.4577V27.7583H32.3416V29.948H30.2651V35.9903H28.173V29.948H27.1426V27.7583H28.173V26.6552C28.173 24.9924 28.8912 23.6094 30.6242 23.6094C31.2175 23.6094 32.2792 23.6423 32.8569 23.8563L32.5446 25.7991Z" fill="#444444" />
                <defs>
                  <filter id="filter0_d_2296_4576" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2296_4576" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2296_4576" result="shape" />
                  </filter>
                </defs>
              </svg>


              <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_2296_4579)">
                  <path fillRule="evenodd" clipRule="evenodd" d="M34 56C47.2548 56 58 45.2548 58 32C58 18.7452 47.2548 8 34 8C20.7452 8 10 18.7452 10 32C10 45.2548 20.7452 56 34 56Z" fill="#27648B" />
                </g>
                <g clipPath="url(#clip0_2296_4579)">
                  <path d="M40.5667 22.9336H28.5C27.1217 22.9336 26 24.0553 26 25.4336V37.5003C26 38.8789 27.1217 40.0003 28.5 40.0003H40.5667C41.9453 40.0003 43.0667 38.8789 43.0667 37.5003V25.4336C43.0667 24.0553 41.9453 22.9336 40.5667 22.9336ZM42.0667 37.5003C42.0667 38.3273 41.3937 39.0003 40.5667 39.0003H28.5C27.673 39.0003 27 38.3273 27 37.5003V25.4336C27 24.6066 27.673 23.9336 28.5 23.9336H40.5667C41.3937 23.9336 42.0667 24.6066 42.0667 25.4336V37.5003Z" fill="white" />
                  <path d="M40.0334 24.9668C39.4821 24.9668 39.0334 25.4155 39.0334 25.9668C39.0334 26.5181 39.4821 26.9668 40.0334 26.9668C40.5848 26.9668 41.0334 26.5181 41.0334 25.9668C41.0334 25.4155 40.5848 24.9668 40.0334 24.9668Z" fill="white" />
                  <path d="M34.5334 26.9668C32.0521 26.9668 30.0334 28.9855 30.0334 31.4668C30.0334 33.9481 32.0521 35.9668 34.5334 35.9668C37.0148 35.9668 39.0334 33.9481 39.0334 31.4668C39.0334 28.9855 37.0148 26.9668 34.5334 26.9668ZM34.5334 34.9668C32.6034 34.9668 31.0334 33.3968 31.0334 31.4668C31.0334 29.5368 32.6034 27.9668 34.5334 27.9668C36.4634 27.9668 38.0334 29.5368 38.0334 31.4668C38.0334 33.3968 36.4634 34.9668 34.5334 34.9668Z" fill="white" />
                </g>
                <defs>
                  <filter id="filter0_d_2296_4579" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2296_4579" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2296_4579" result="shape" />
                  </filter>
                  <clipPath id="clip0_2296_4579">
                    <rect width="17.0667" height="17.0667" fill="white" transform="translate(26 22.9336)" />
                  </clipPath>
                </defs>
              </svg>


              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_2296_4573)">
                  <path fillRule="evenodd" clipRule="evenodd" d="M30 48C41.0457 48 50 39.0457 50 28C50 16.9543 41.0457 8 30 8C18.9543 8 10 16.9543 10 28C10 39.0457 18.9543 48 30 48Z" fill="white" />
                </g>
                <path d="M37.3168 23.1597C36.7363 23.4143 36.1178 23.5831 35.4729 23.665C36.1363 23.2689 36.6426 22.6465 36.8807 21.8963C36.2622 22.265 35.5792 22.5255 34.8514 22.6709C34.2641 22.0455 33.427 21.6582 32.5139 21.6582C30.7422 21.6582 29.3158 23.0963 29.3158 24.8592C29.3158 25.1128 29.3373 25.3567 29.39 25.5889C26.7295 25.4592 24.3753 24.1841 22.7939 22.2416C22.5178 22.7206 22.3558 23.2689 22.3558 23.8592C22.3558 24.9675 22.9265 25.9499 23.7773 26.5187C23.2631 26.5089 22.7587 26.3597 22.3314 26.1245C22.3314 26.1343 22.3314 26.147 22.3314 26.1597C22.3314 27.7148 23.4407 29.0065 24.8953 29.3041C24.6348 29.3753 24.3509 29.4094 24.0563 29.4094C23.8514 29.4094 23.6446 29.3977 23.4504 29.3548C23.8651 30.6221 25.0417 31.5538 26.4407 31.5841C25.3519 32.4358 23.9695 32.9489 22.4729 32.9489C22.2104 32.9489 21.9587 32.9372 21.707 32.905C23.1246 33.8192 24.8046 34.3411 26.6163 34.3411C32.5051 34.3411 35.7246 29.4631 35.7246 25.2348C35.7246 25.0933 35.7197 24.9567 35.7129 24.8211C36.348 24.3704 36.8817 23.8075 37.3168 23.1597Z" fill="#444444" />
                <defs>
                  <filter id="filter0_d_2296_4573" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2296_4573" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2296_4573" result="shape" />
                  </filter>
                </defs>
              </svg>


            </div>


            {/* <ul className="list-none leading-[30px] space-y-1 text-[16px] font-[400]  text-[#444444]">
              <a
                href="http://localhost:3001/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <li className="">Become Vendor</li>
              </a>
            </ul> */}
          </div>
        </div>
        <hr className="border-[1px] mx-auto  lg:px-[calc((100%-1250px)/2)] w-full xl:w-[87%] mt-5  border-[#999999]" />
        <p className="lg:px-[calc((100%-1250px)/2)] text-start py-3 text-[#ffffff] text-[10px] lg:text-[14px] ">
          Copyright 2024. All rights reserved - Wehelpufirst - Designed and
          Developed by Meerana Technologies LLP
        </p>
      </footer>
    </>
  );
};

export default Footer;
